export default __webpack_public_path__ + "static/media/logo.1cd7c71f.png";